import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import { useFetch } from '../../hooks/useFetch';
import { fetchPrivacy } from '../../api/api';
import { useTranslation } from 'react-i18next';


const Privacy = () => {
    const { data, isLoading, error } = useFetch(["privacy"], fetchPrivacy);
    const { t } = useTranslation();
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={t('pageTitles.privacy')} pagesub={t('pageTitles.privacy')} />
            {isLoading ? <>Loading...</> : error ? <>Error</> : (
                <div className=' section-padding'>
                    <div className="container">
                        <div dangerouslySetInnerHTML={{ __html: data?.data?.privacyPolicy }} />
                    </div>
                </div>
            )}

            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default Privacy;

